import React, {Component} from 'react';
import {Buffer} from "buffer";
import Cookies from "universal-cookie";
import MainLayout from "../../components/layouts/MainLayout";
import {withRouter} from "../../hoc/withRouter";
import {Table, message, Form, DatePicker, Button, Tag, Tooltip, Modal} from 'antd';
import {offerApiServices} from "../../services/offer/OfferApiService";
import {ListPrebookingStates} from "./types/ListPrebookingTypes";
import withAuth from "../../hoc/withAuth";
import moment from "moment";
import {CopyOutlined, SearchOutlined} from "@ant-design/icons";
import currencyFormat from "../../helper/currencyFormat";
import DetailPrebooking from "../../components/offer/DetailPrebooking";

export interface LogAutomaticClosingProps {
}

class ListPrebooking extends Component<LogAutomaticClosingProps & any, ListPrebookingStates> {
    private readonly initState!: ListPrebookingStates;
    private uDealer = JSON.parse(Buffer.from(new Cookies().get('_d'), "base64").toString());
    private tableColumnNoPaid: any = [
        {
            title: 'PreBooking Code',
            dataIndex: 'transaction_code',
            render: ((value: string, row: []) => {
                return <React.Fragment>
                    <span className={`font-90-link`} onClick={event => this.showPrebookingDetail(row)}>{value}</span>
                    &nbsp;
                    <Tooltip title="Click untuk copy kode prebooking" color={'cyan'}>
                        <CopyOutlined className={'small-avatar-link'} onClick={event => this.copyToClipboard(value)}/>
                    </Tooltip>
                </React.Fragment>

            })
        },
        {
            title: 'Area & Status PreBooking',
            dataIndex: 'prebooking_status',
            render: ((value: string, row: any) => {
                let status: any = "-";
                if (value.toUpperCase() === 'OPEN') {
                    status = <Tag style={{fontSize: "70%", display: "inline"}} color="#108ee9">Open</Tag>;
                } else if (value.toUpperCase() === 'CANCEL') {
                    status = <Tag style={{fontSize: "70%", display: "inline"}} color="#f50">{(row?.cancel_admin_id === 'SYSTEM') ? "Cancel System" : "Cancel"}</Tag>;
                } else if (value.toUpperCase() === 'ORDER') {
                    status = <Tag style={{fontSize: "70%", display: "inline"}} color="#87d068">Order</Tag>;
                } else if (value.toUpperCase() === 'OFFER') {
                    status = <Tag style={{fontSize: "70%", display: "inline"}} color="#87d068">Offer</Tag>;
                }
                return (
                    <React.Fragment>
                        <span className={`font-80-grey`}>{row?.area?.toUpperCase()}</span>
                        <br/>{status}
                    </React.Fragment>
                )
            })
        },
        {
            title: 'Sumber & Tgl',
            dataIndex: 'name',
            render: ((value: string, row: any) => {
                return <React.Fragment>
                    <span className={`font-90`}>{row?.payment?.time?.toString()?.replace('T', " ")?.substring(0, 10)}</span><br/>
                    <span className={`font-85-red`}>{row?.source}</span>
                </React.Fragment>
            })
        },
        {
            title: 'Konsumen',
            dataIndex: 'name',
            render: ((value: string, row: any) => {
                return <React.Fragment>
                    <span className={`font-90`}>{value}</span><br/>
                    <span className={`font-80-grey`}>{row?.phone_number}</span>
                </React.Fragment>
            })
        },
        {
            title: 'PreBooking',
            dataIndex: 'prebooking_code',
            render: ((value: string, row: any) => {
                return <React.Fragment>
                    <span className={`font-90`}>{value}</span><br/>
                    <span className={`font-80-grey`}>{currencyFormat(row?.payment?.amount)}</span>
                </React.Fragment>
            })
        },
        {
            title: 'Catatan',
            dataIndex: 'notes',
            render: ((value: string, row: []) => {
                return <span className={`font-90`}>{value?.toString()}</span>
            })
        },
    ];

    constructor(props: LogAutomaticClosingProps & any | any) {
        super(props);

        const finalDealerCode = props.match.params.dealerCode.replace(/-/g, '#');
        const picked = this.uDealer.find((o: { DealerCode: any; }) => o.DealerCode === finalDealerCode);
        const companyCode = picked?.DealerCompany ?? "AMARTA";

        this.initState = {
            processingFetchTableData: false,
            dealerCode: props.match.params.dealerCode.replace(/-/g, '#'),
            companyCode: companyCode,
            dataTable: [],
            filterStartDate: moment().format('YYYY-MM-DD'),
            filterEndDate: moment().format('YYYY-MM-DD'),
            showModalDetail: false,
            chosenPrebookingCode: "",
        }
        this.state = {...this.initState}
    }

    onDealerChange = async (data: any) => {
        this.setState({
            processingFetchTableData: false,
            dealerCode: data.value,
        });
    }

    fetchData = async () => {
        this.setState({
            processingFetchTableData: true,
            dataTable: [],
        });

        try {
            const dataServer = await offerApiServices.getPrebookingByDate({
                companyCode: this.state.companyCode,
                startDate: moment(this.state.filterStartDate).format("YYYY-MM-DD"),
                endDate: moment(this.state.filterEndDate).format("YYYY-MM-DD")
            });
            this.setState({
                dataTable: dataServer.data.data,
                processingFetchTableData: false,
            });
        } catch (e) {
            this.setState({
                dataTable: [],
                processingFetchTableData: false,
            });
            message.error(e?.toString());
        }
    }

    showPrebookingDetail = async (data: any) => {
        this.setState({
            showModalDetail: true,
            chosenPrebookingCode: data.transaction_code
        })
    }

    copyToClipboard = async (data: any) => {
        await navigator.clipboard.writeText(data);
        message.info('Kode Berhasil di Copy');
    }

    onFieldChange = <T extends keyof Pick<any, "filterStartDate" | "filterEndDate">>(target: T, value: any) => {
        const currentState: any = {...this.state};
        switch (target) {
            case "filterStartDate":
                currentState.filterStartDate = value;
                break;
            case "filterEndDate":
                currentState.filterEndDate = value;
                break;
        }
        currentState.dataTable = [];
        this.setState({
            ...currentState,
        });
    }

    render() {
        return (
            <React.Fragment>
                <MainLayout noPadNoMar={true} onChangeDealer={this.onDealerChange} breadcrumbPath={`Offer`} breadcrumbMenu={`List PreBooking`} defaultSelectedKeys={['m-list-prebooking']} defaultOpenKeys={['sm-offer']}>
                    <div style={{paddingLeft: 10, paddingRight: 10, paddingBottom: 20}}>
                        <div style={{float: "right", fontSize: "85%", color: "grey"}}>Organization: {this.state.companyCode}</div>
                        <br/>
                        <Form layout={`inline`}>
                            <Form.Item className={'padTop-10'} label="">
                                <i className={`small-text-grey`}>Tgl Awal</i><br/>
                                <DatePicker defaultValue={moment(this.state.filterStartDate, 'YYYY-MM-DD')} onChange={event => this.onFieldChange("filterStartDate", event)} format={'YYYY-MM-DD'}/>
                            </Form.Item>
                            <Form.Item className={'padTop-10'} label="">
                                <i className={`small-text-grey`}>Tgl Akhir</i><br/>
                                <DatePicker defaultValue={moment(this.state.filterEndDate, 'YYYY-MM-DD')} onChange={event => this.onFieldChange("filterEndDate", event)} format={'YYYY-MM-DD'}/>
                            </Form.Item>
                            <Form.Item className={'padTop-20'}>
                                <Button loading={this.state.processingFetchTableData} onClick={this.fetchData} type="primary" icon={<SearchOutlined/>}>Cari Data</Button>
                            </Form.Item>
                        </Form>
                    </div>

                    <div style={{backgroundColor: "#f0f2f5"}}> &nbsp; </div>

                    <Table
                        rowKey={'transaction_code'}
                        size={'small'}
                        scroll={{x: 'calc(500px + 50%)'}}
                        loading={this.state.processingFetchTableData}
                        columns={this.tableColumnNoPaid}
                        dataSource={this.state.dataTable}
                        pagination={{pageSize: 50000}}
                    />
                </MainLayout>

                <Modal
                    open={this.state.showModalDetail}
                    title={`Detail Prebooking`}
                    onOk={() => this.setState({showModalDetail: false})}
                    onCancel={() => this.setState({showModalDetail: false})}
                    cancelText={'Tutup'} okText={false}
                    footer={[
                        <Button key="back" type="default" onClick={() => this.setState({showModalDetail: false})}>Tutup</Button>,
                    ]}
                >
                    <DetailPrebooking companyCode={this.state.companyCode} prebookingCode={this.state.chosenPrebookingCode} time={Math.floor(+new Date() / 1000)}/>
                </Modal>
            </React.Fragment>
        );
    }
}

export default (withAuth(withRouter(ListPrebooking), 49));
